
import React from "react";
import { Input } from "@/components/ui/input";
import { useTranslations } from "use-intl";

interface AmountRangeFilterProps {
  minAmount: string | number;
  maxAmount: string | number;
  onMinAmountChange: (value: string) => void;
  onMaxAmountChange: (value: string) => void;
}

const AmountRangeFilter: React.FC<AmountRangeFilterProps> = ({
  minAmount,
  maxAmount,
  onMinAmountChange,
  onMaxAmountChange,
}) => {
  const t = useTranslations("consultantPayables.filters");
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">{t("amountRange")}</label>
      <div className="flex space-x-2">
        <Input
          placeholder={t("min")}
          type="number"
          value={minAmount}
          onChange={(e) => onMinAmountChange(e.target.value)}
          className="w-full"
        />
        <Input
          placeholder={t("max")}
          type="number"
          value={maxAmount}
          onChange={(e) => onMaxAmountChange(e.target.value)}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default AmountRangeFilter;
